<template>
  <div 
    class="mini-window"
    :style="{
      width: `${width}px`,
      height: `${height}px`,
    }"
  >
    <div class="mini-window--bar">
      <div class="mini-window--expand" @click="expand">
        <img src="~@/assets/images/throwingPic/max.svg" alt="">
      </div>
      <div class="mini-window--close" @click="close">
        <img src="~@/assets/images/throwingPic/close3.svg" alt="">
      </div>
    </div>
    <div class="mini-window--content">
      <template v-if="imgList.length > 0">
        <div 
          class="img-list"
          :class="{
            'img-list__dense': imgList.length > 4,
          }"
        >
          <div v-for="item in imgList" :key="item.url" class="img-wrap">
            <div class="img--content-wrap">
              <img
                :src="item.url"
                class="img--content" alt="">
            </div>
          </div>
        </div>
      </template>
      <div v-else class="img-list">
        <div class="img-wrap empty">
          <div class="img--content-wrap">
            <img
              src="~@/assets/images/throwingPic/empty_img.svg"
              class="img--content" alt="">
            <div class="empty-tip">
              <div>当前投图内容为空</div>
              <div>请在手机端添加投图图片</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [ 'imgList' ],
  data() {
    return {
      width: 0,
      height: 0,
    };
  },
  watch: {
    imgList() {
      this.setWinBounds();
    },
  },
  created() {
    this.setWinBounds();
  },
  methods: {
    close() {
      this.$emit('close');
    },

    expand() {
      this.$emit('expand');
    },

    setWinBounds() {
      const count = Math.max(this.imgList.length, 1);
      let width = 0;
      let height = 0;

      if (count <= 4) {
        width = 184 * count + 20;
        height = 380;
      } else {
        width = 184 * 4 + 20;
        height = 205 * 2 + 60;
      }

      this.width = width;
      this.height = height;
    },
  }
};
</script>

<style lang="scss" scoped>
.mini-window {
  position: fixed;
  right: 24px;
  bottom: 24px;
  z-index: 9;
  border-radius: 4px;
  background-color: rgba(0, 0, 0, .75);
}

.mini-window--bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 40px;
  padding: 0 16px;
  border-radius: 6px 6px 0 0;
  background-color: rgba(0, 0, 0, .75);
}

.mini-window--expand,
.mini-window--close {
  display: block;
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.mini-window--content {
  padding: 10px;
}

.img-list {
  display: flex;
  align-items: center;
  justify-content: center;
}

.img-list.img-list__dense {
  flex-wrap: wrap;
  transform: initial;
  justify-content: initial;
}

.img-wrap {
  width: 184px;
  height: 320px;
  padding: 6px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.1);

  &.empty {
    .empty-tip {
      margin-top: 14px;
      text-align: center;
      font-size: 12px;
      line-height: 18px;
      color: #51A4FF;
    }

    .img--content-wrap {
      flex-direction: column;
      align-items: center;
    }

    .img--content {
      width: 48px;
      height: 41px;
    }
  }
}

.img-list__dense .img-wrap {
  height: 205px;
  padding: 5px;
}

.img--content-wrap {
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
}

.img--content {
  display: block;
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  -webkit-user-drag: none;
}
</style>